import { DEFAULT_SQ1_SCHEME, SOLVED_BOTTOM_PIECES, SOLVED_TOP_PIECES, } from "./constants";
import { Group } from "./../../geometry/group";
import { ATAN_15_DEG, DEG_30_RADIANS, DEG_60_RADIANS, } from "./../../math/constants";
import { PIECE_TYPE } from "./enum";
export class Square1Builder {
    constructor(topLayer = SOLVED_TOP_PIECES, bottomLayer = SOLVED_BOTTOM_PIECES, middleRotated = false, scheme = DEFAULT_SQ1_SCHEME, sideLength = 0.7) {
        this.scheme = scheme;
        this.sideLength = sideLength;
        this.halfSide = this.sideLength / 2;
        this.halfEdgePiece = this.halfSide * ATAN_15_DEG;
        this.layerWidth = this.halfSide - this.halfEdgePiece;
        this.middleWidth = this.sideLength - 2 * this.layerWidth;
        this.halfMiddleWidth = this.middleWidth / 2;
        this.borderLayerWidth = this.sideLength * 0.2;
        this.outerHalfSide = (sideLength + this.borderLayerWidth) / 2;
        this.outerHalfEdgePiece = this.outerHalfSide * ATAN_15_DEG;
        this.pieces = this.buildSquare1(topLayer, bottomLayer, middleRotated);
        this.group = new Group(this.pieces);
    }
    makeLayer(pieces) {
        let geometry = [];
        let angle = Math.PI;
        pieces.forEach((piece, index) => {
            switch (piece.type) {
                case PIECE_TYPE.CORNER:
                    const corner = this.square1Corner(piece.colors[0], piece.colors[1], piece.colors[2]);
                    corner.rotate(angle, 0, 0, 1);
                    geometry.push(corner);
                    angle -= DEG_60_RADIANS;
                    break;
                case PIECE_TYPE.EDGE:
                    const edge = this.square1Edge(piece.colors[0], piece.colors[1]);
                    edge.rotate(angle - DEG_60_RADIANS, 0, 0, 1);
                    geometry.push(edge);
                    angle -= DEG_30_RADIANS;
                    break;
            }
        });
        return geometry;
    }
    /**
     * Not implemented. Just here for {@link Visualizer}'s sake
     */
    setColors(colors) { }
}
